var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.3193 23.9732C19.203 23.9732 23.9727 19.2035 23.9727 13.3198C23.9727 7.43616 19.203 2.6665 13.3193 2.6665C7.43568 2.6665 2.66602 7.43616 2.66602 13.3198C2.66602 19.2035 7.43568 23.9732 13.3193 23.9732Z",
    fill: "#8392A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2934 21.3201C29.2934 25.7201 25.7201 29.2934 21.3201 29.2934C18.6001 29.2934 16.2134 27.9334 14.7734 25.8668C20.5868 25.2134 25.2134 20.5868 25.8668 14.7734C27.9334 16.2134 29.2934 18.6001 29.2934 21.3201Z",
    fill: "#8392A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.266 12.9469L12.066 11.8269C11.746 11.7202 11.6793 11.6935 11.6793 11.2269C11.6793 10.8802 11.9193 10.6002 12.226 10.6002H14.226C14.6527 10.6002 14.9993 10.9869 14.9993 11.4669C14.9993 12.0135 15.4527 12.4669 15.9993 12.4669C16.546 12.4669 16.9993 12.0135 16.9993 11.4669C16.9993 9.93354 15.8127 8.68021 14.3327 8.61354V8.54687C14.3327 8.00021 13.8793 7.54688 13.3327 7.54688C12.786 7.54688 12.3327 7.98687 12.3327 8.54687V8.61354H12.2127C10.8127 8.61354 9.66602 9.78688 9.66602 11.2402C9.66602 12.5069 10.226 13.3202 11.386 13.7202L14.5993 14.8402C14.9193 14.9469 14.986 14.9735 14.986 15.4402C14.986 15.7869 14.746 16.0669 14.4393 16.0669H12.4393C12.0127 16.0669 11.666 15.6802 11.666 15.2002C11.666 14.6535 11.2127 14.2002 10.666 14.2002C10.1193 14.2002 9.66602 14.6535 9.66602 15.2002C9.66602 16.7335 10.8527 17.9869 12.3327 18.0535V18.1335C12.3327 18.6802 12.786 19.1335 13.3327 19.1335C13.8793 19.1335 14.3327 18.6802 14.3327 18.1335V18.0669H14.4527C15.8527 18.0669 16.9993 16.8935 16.9993 15.4402C16.9993 14.1735 16.426 13.3602 15.266 12.9469Z",
    fill: "#8392A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethod);
export default __webpack_public_path__ + "static/media/payment_method.49a032694a19db036466497c0c1d1580.svg";
export { ForwardRef as ReactComponent };